module.exports = __webpack_public_path__ + "static/media/green_dragon.44c3ab20.webp";